module.exports = __webpack_public_path__ + "img/setting_icon.199f4140.svg";